module.exports = __webpack_public_path__ + "static/media/Glucerna.a469c7df.png";